import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '292px',
    height: "30px",
    padding: "4px 12px",
    background: "rgba(255 , 255  , 255 , 1)",
    borderColor: "rgba(43, 57, 64, 0.07)",
    borderRadius: "4px",
    borderStyle: "solid",
    borderWidth: "1px",
    "&:before": {
      display: "none"
    },
    "&:after": {
      display: "none"
    },
    "&.focus": {
      borderColor: theme.palette.primary.main
    }
  },
  formControl: {},
  focused: {},
  disabled: {},
  underline: {},
  error: {
    boxShadow: '0 0 2px 1px red'
  },
  multiline: {},
  fullWidth: {},
  input: {
    userSelect: "none",
    fontSize: '14px',
    lineHeight: '17px',
  },
  inputMarginDense: {},
  inputMultiline: {},
  inputTypeSearch: {}
}));